var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","role":"presentation","viewBox":_vm.computedViewBox,"aria-labelledby":_vm.id}},[_c('title',{attrs:{"id":_vm.id}},[_vm._v(_vm._s(_vm.name)+" 아이콘")]),_c('g',{ref:"svgWrap",attrs:{"shape-rendering":"geometricPrecision"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }